export const PREFERRED_LOCALE_LOCAL_STORAGE_KEY = "preferredLocale";
